import script from "./registerSjInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./registerSjInfo.vue?vue&type=script&setup=true&lang=js"

import "./registerSjInfo.vue?vue&type=style&index=0&id=2132573d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2132573d"]])

export default __exports__